import { ACTIONS } from '../Constants';

const initialState = {
    byId: {},
    segments: {}
};

const buildKey = (parentType, parentId) => `${parentType}-${parentId}`;

const addFileToState = (state, file) => {
    const segmentKey = buildKey(file.parentType, file.parentId);

    if (state[segmentKey]) {
        state[segmentKey][file._id] = file;
    } else {
        state[segmentKey] = { [file._id]: file };
    }
    state.byId[file._id] = file;
};

const filesReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
        case ACTIONS.UPLOAD_NEW_FILE: {
            const { file } = action.payload;
            newState = {
                ...state
            };

            addFileToState(newState, file);

            return newState;
        }
        case ACTIONS.GET_MANY_FILES: {
            const { files } = action.payload;

            newState = {
                ...state
            };

            for (let i = 0; i < files.length; i += 1) {
                addFileToState(newState, files[i]);
            }
            return newState;
        }
        default:
            return state;
    }
};
export default filesReducer;
